/* eslint-disable */
import {
  enumTelas,
  enumPermissoesTela
} from "../../shared/helpers/Enum";
import {
  contemPermissaoTela
} from "../../shared/helpers/Permissoes";
import IconesSvg from "@/shared/assets/icones/index"
import axios from 'axios';

export default {
  mixins: [IconesSvg],
  data() {
    return {
      habilitarRecursosProprios: false,
      habilitarDashboard: false
    }
  },
  beforeMount() {
    this.getHabilitarRecursosProprios();
    this.getHabilitarDashboard();
  },
  methods: {
    redirecionar(index) {
      this.$router.push(this.listaTelasFilter[index].url).catch(err => {})
    },
    habilitarTela(telas, configuracaoEnv, novaTela){
      if(configuracaoEnv === "true")
        telas.push(novaTela)
        
      return telas
    },
    async getHabilitarRecursosProprios() {
      const resposta = await axios.get(this.CriarUrl({
        resource: 'parametros?chave=enable.app.recursos.proprios.vue'
      }));
      if (!resposta) return;
      this.habilitarRecursosProprios = resposta.data.valor;
    },
    async getHabilitarDashboard() {
      const resposta = await axios.get(this.CriarUrl({
        resource: 'parametros?chave=enable.app.dashboard.vue'
      }));
      console.log(resposta);

      if (!resposta) return;
      this.habilitarDashboard = resposta.data.valor === 'true';
      console.log(resposta.data.valor === 'true');

    }
  },
  computed: {
    listaTelas() {
      let telas = [{
        componentSvg: this.ValidacaoSvg,
        titulo: enumTelas[enumPermissoesTela.VALIDACAO].titulo,
        url: enumTelas[enumPermissoesTela.VALIDACAO].url,
        tela: enumTelas[enumPermissoesTela.VALIDACAO].tela
      },
      {
        componentSvg: this.PrestadoresSvg,
        titulo: enumTelas[enumPermissoesTela.PRESTADORES].titulo,
        url: enumTelas[enumPermissoesTela.PRESTADORES].url,
        tela: enumTelas[enumPermissoesTela.PRESTADORES].tela
      },
      {
        icone: "settings",
        titulo: enumTelas[enumPermissoesTela.ADMINISTRACAO].titulo,
        url: enumTelas[enumPermissoesTela.ADMINISTRACAO].url,
        tela: enumTelas[enumPermissoesTela.ADMINISTRACAO].tela,
        especuraDoIcone: 1.5
      },
      {
        icone: "file-text",
        titulo: enumTelas[enumPermissoesTela.RELATORIOS].titulo,
        url: enumTelas[enumPermissoesTela.RELATORIOS].url,
        tela: enumTelas[enumPermissoesTela.RELATORIOS].tela,
        especuraDoIcone: 1.5
      },
      // {
      //   icone: "file-text",
      //   titulo: enumTelas[enumPermissoesTela.CONVERSOR_XML].titulo,
      //   url: enumTelas[enumPermissoesTela.CONVERSOR_XML].url,
      //   tela: enumTelas[enumPermissoesTela.CONVERSOR_XML].tela,
      //   especuraDoIcone: 1.5
      // },
      
     ]

      telas = this.habilitarTela(telas, this.habilitarDashboard,{
            icone: "pie-chart",
            titulo: enumTelas[enumPermissoesTela.DASHBOARD].titulo,
            url: enumTelas[enumPermissoesTela.DASHBOARD].url,
            tela: enumTelas[enumPermissoesTela.DASHBOARD].tela,
            especuraDoIcone: 1.5
          }
      );

     telas = this.habilitarTela(telas, this.habilitarRecursosProprios,{
        componentSvg: this.RecursosPropriosSvg,
        titulo: enumTelas[enumPermissoesTela.RECURSOS_PROPRIOS].titulo,
        url: enumTelas[enumPermissoesTela.RECURSOS_PROPRIOS].url,
        tela: enumTelas[enumPermissoesTela.RECURSOS_PROPRIOS].tela,
        especuraDoIcone: 1.5
      }
    )
      return telas 
    },
    listaTelasFilter() {
      return this.listaTelas.filter(e => {
        return contemPermissaoTela(
          e.tela,
          this.$store.getters.getPermissoesUsuario.telas 
        );
      });
    }
  }
};
